import { Col, Row } from "reactstrap";
import ComplianceReadinessChart from "./ComplianceReadinessChart";
import FrameworkCoverageCardsSection from "./FrameworkCoverageCardsSection";

import { getDashboardMetric, isTisaxFramework } from "src/modules/data-protection/helpers/Controls";

const ComplianceReadinessSection = ({ t, dashboardData, frameworkLabelMap, selectedFramework }) => {
  const showMaturity = isTisaxFramework(selectedFramework);
  const readinessScore = getDashboardMetric(dashboardData?.kpis?.readiness_score).percent;
  const applicabilityScore = getDashboardMetric(
    dashboardData?.kpis?.applicable_controls
  ).percent;
  const maturityMetric = getDashboardMetric(dashboardData?.kpis?.avg_maturity_level);
  const maturityScore =
    maturityMetric.percent ||
    Math.round((Number(maturityMetric.amount) / 5) * 100);
  const openTasks = getDashboardMetric(dashboardData?.tasks_and_actions?.open_tasks).amount;
  const completedTasks = getDashboardMetric(
    dashboardData?.tasks_and_actions?.completed
  ).amount;
  const taskHealthScore = Math.round(
    (completedTasks / Math.max(openTasks + completedTasks, 1)) * 100
  );
  return (
    <Row className="mb-4">
      <Col lg="4" md="12" className="mb-3">
        <ComplianceReadinessChart
          t={t}
          readinessScore={readinessScore}
          applicabilityScore={readinessScore}
          maturityScore={maturityScore}
          taskHealthScore={taskHealthScore}
          showMaturity={showMaturity}
        />
      </Col>

      <Col lg="8" md="12" className="mb-3">
        <FrameworkCoverageCardsSection
          t={t}
          dashboardData={dashboardData}
          frameworkLabelMap={frameworkLabelMap}
          selectedFramework={selectedFramework}
        />
      </Col>
    </Row>
  );
};

export default ComplianceReadinessSection;
